import { FC } from 'react';

import {
  CLIMATE_RISK_FACT_TYPES,
  ClimateRiskRatingOrder,
  ClimateRiskRatingsByIndex,
  PlotReportFactLabelNameEnum,
  Scenario,
} from '@/api/rest/resources/types/fact';
import { WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useOrganizationIndicatorReportingFact } from '@/pages/shared/hooks/useOrganizationFact';
import { isNullish } from '@/utils/booleans';

export const RisksTile: FC = () => {
  const facts = useOrganizationIndicatorReportingFact<number>(Object.keys(CLIMATE_RISK_FACT_TYPES), null, {
    [PlotReportFactLabelNameEnum.scenario]: Scenario.baseline,
  });

  const risks = Object.keys(facts)
    .filter((factType) => {
      const risk = facts[`${factType}`];
      return !isNullish(risk?.value);
    })
    .map((factType) => facts[`${factType}`])
    .sort((a, b) => {
      const aRating = ClimateRiskRatingsByIndex[a?.value as number];
      const bRating = ClimateRiskRatingsByIndex[b?.value as number];
      return ClimateRiskRatingOrder[aRating as keyof typeof ClimateRiskRatingOrder] >
        ClimateRiskRatingOrder[bRating as keyof typeof ClimateRiskRatingOrder]
        ? -1
        : 1;
    })
    .map((fact) => fact?.name);
  const riskOverviewConfig = {
    name: 'climate_risk_overview',
    type: WidgetType.o_c_risk_overview,
    visible: true,
    relatedData: {
      className: 'flex flex-row flex-wrap gap-4',
      risks,
    },
  };

  return (
    <div className='mb-10'>
      <WidgetSlotRenderer nestedWidget={riskOverviewConfig} />
    </div>
  );
};
